export const dayTone = day => {
  if (day.today)   return "bg-brand-50/50"
  if (day.holiday) return "bg-amber-50/60"
  if (day.weekend) return "bg-slate-50"
  return "bg-white"
}
